// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"beh_a bho_qn bho_qo bho_ua bho_cy bho_ty bho_go bho_ka"};